import React from "react";
import "../CSS/Footer.css";
import {
  HomeIcon,
  ChatBubbleLeftRightIcon,
  InformationCircleIcon,
  TicketIcon,
} from "@heroicons/react/24/outline";
import { useDispatch, useSelector } from "react-redux";
import { createConvo } from "../Redux/Actions/convoActions";
import io from "socket.io-client";
const socket = io(`${process.env.REACT_APP_CHAT_SERVER}`);

function Footer({
  view,
  setView,
  activeIcon,
  setActiveIcon,
  setupDetails,
  widgetConfigs,
}) {
  const convo = useSelector((state) => state.convo);
  const dispatch = useDispatch();
  return (
    <div className="dexkor-footer border-t border-gray-200 mt-3 animate-fadeIn">
      {view !== "LiveChat" &&
        view !== "message" &&
        view !== "MessageDetails" && (
          <div className="flex justify-around p-3 text-xs">
            <div
              onClick={() => {
                setView("LandingWindow");
                setActiveIcon("home");
              }}
              style={{
                color:
                  activeIcon === "home" &&
                  setupDetails?.widgetCustomizations?.primaryColor,
              }}
              className={`flex flex-col items-center cursor-pointer transition duration-300 transform ${
                activeIcon === "home"
                  ? "text-blue-600 scale-110"
                  : "hover:scale-105"
              }`}
            >
              <HomeIcon className="h-5 w-5" />
              <div>Home</div>
            </div>
            {setupDetails?.widgetCustomizations?.conversation && (
              <div
                onClick={() => {
                  setActiveIcon("messages");
                  setView("Convo");
                  if (convo === null) {
                    dispatch(createConvo(widgetConfigs));
                  }
                }}
                style={{
                  color:
                    activeIcon === "messages" &&
                    setupDetails?.widgetCustomizations?.primaryColor,
                }}
                className={`flex flex-col items-center cursor-pointer transition duration-300 transform ${
                  activeIcon === "messages"
                    ? "text-blue-600 scale-110"
                    : "hover:scale-105"
                }`}
              >
                <ChatBubbleLeftRightIcon className="h-5 w-5" />
                <div>Convo</div>
              </div>
            )}
            {/* {setupDetails?.widgetCustomizations?.ticket && ( */}
            <div
              onClick={() => {
                setActiveIcon("tickets");
                setView("chatList");
              }}
              style={{
                color:
                  activeIcon === "tickets" &&
                  setupDetails?.widgetCustomizations?.primaryColor,
              }}
              className={`flex flex-col items-center cursor-pointer transition duration-300 transform ${
                activeIcon === "tickets"
                  ? "text-blue-600 scale-110"
                  : "hover:scale-105"
              }`}
            >
              <TicketIcon className="h-5 w-5" />
              <div>Tickets</div>
            </div>
            {/* )} */}
            {/* <div
              onClick={() => {
                setActiveIcon("help");
                setView("Help");
              }}
              style={{
                color:
                  activeIcon === "help" &&
                  setupDetails?.widgetCustomizations?.primaryColor,
              }}
              className={`flex flex-col items-center cursor-pointer transition duration-300 transform ${
                activeIcon === "help"
                  ? "text-blue-600 scale-110"
                  : "hover:scale-105"
              }`}
            >
              <InformationCircleIcon className="h-5 w-5" />
              <div>Help</div>
            </div> */}
          </div>
        )}
      <p className="text-xs">
        <span className="text-gray-500 mr-1">Powered by</span>
        <a
          href="https://dexkor.com/"
          style={{
            background: `linear-gradient(90deg, ${
              setupDetails?.widgetCustomizations?.primaryColor || "#4c73de"
            } 0%,  ${
              setupDetails?.widgetCustomizations?.secondaryColor || "#2a4dad"
            } 100%)`,
            backgroundClip: "text",
            color: "transparent",
            fontWeight: "bold",
          }}
          target="_blank"
          rel="noopener noreferrer"
        >
          <span>DexKor</span>
        </a>
      </p>
    </div>
  );
}

export default Footer;
